module.exports = __webpack_public_path__ + "static/media/importICloud1.393db3fc.png";